angular.module('lf.common')

.factory('helpers', function () {

  var helpers = {

    range: function (from, to, step) {
      var range = [];
      for (; from <= to; from += (step || 1)) {
        range.push(from);        
      }
      return range;
    },
    
    selectRange: function (from, to, step) {
      var range = [];
      for (; from <= to; from += (step || 1)) {
        range.push({text: from, content: from.toString(), value: from});
      }
      return range;
    },

    creditCardForm: {

      getYears: function (from, to) {
        from = from || (new Date()).getFullYear();
        to = from + (to || 15);
        return helpers.selectRange(from, to);
      },

      getMonths: function () {
        return lf.data.formData.months;
      }

    },
    getRedeemLocations: function () {
    	   var locations = lf.data.formData.redeemLocations;
    	   if(typeof locations != 'undefined' && locations.length > 0) {
    		   return lf.data.formData.redeemLocations;
    	   }
          return false;
        },
    
    getStates: function () {
      return lf.data.formData.billingStates;
    },
    
    getBillingCountries: function () {
      return lf.data.formData.billingCountries;
    },
    
    redirect : function (url) {
      if (window.location.href.slice(-url.length) === url) return;
      window.location.href = url;
    },
    
    parseInlineOptions: function (str) {
      var options = {};
      if (!str || typeof str !== 'string') return options;
      str.split(/\s/).forEach(function (option) {
        var kv = option.match(/^(.+?)=(.+)$/);
        if (kv) {
          options[kv[1]] = kv[2];
        } else {
          options[option] = true;
        }
      });
      return options;
    },
  
  	utils: {
	  addCookie: function (name, value, expires, path, domain, secure) {
		  // name: cookie name
		  // value: cookie value
		  // expires: a number that represents cookie expiration time in days
		var today = new Date();
		today.setTime(today.getTime());
		if(expires) {
			expires = expires * 1000 * 60 * 60 * 24;
		}
		
		var expires_date = new Date( today.getTime() + (expires) );
		document.cookie = name + "=" + escape(value) + 
							( ( expires && expires >= 0) ? ";expires=" + expires_date.toGMTString() : "" ) +
							( ( path ) ? ";path=" + path : "" ) +
							( ( domain ) ? ";domain=" + domain : "" ) +
							( ( secure ) ? ";secure=" : "" );
										
	  },
	  getCookie: function (c_name, findLast) {
		  	console.log('helper.utils.getCookie function called.');
			// there is a bug in QT Browser (does not happen Chrome, Firefox) :
			// if request already has a cookie with name say x and you to add another cookie with the same name, x, 
			// QT Browser maintains two separate cookies (instead of updating the old cookie)
			// findLast = true will make sure that the most recently added (new) cookie will be returned instead of old.. 
				
			var i, x, y, ARRcookies=document.cookie.split(";");
			if(findLast) {
				for(i=ARRcookies.length - 1; i >= 0; i--) {
					x = ARRcookies[i].substr(0,ARRcookies[i].indexOf("="));
				  	y = ARRcookies[i].substr(ARRcookies[i].indexOf("=")+1);
				  	x = x.replace(/^\s+|\s+$/g,"");
				  	if (x == c_name) {
			  			return unescape(y);
				    }
				}
			} else {
				for (i=0; i < ARRcookies.length; i++) {
			  		x = ARRcookies[i].substr(0,ARRcookies[i].indexOf("="));
				  	y = ARRcookies[i].substr(ARRcookies[i].indexOf("=")+1);
				  	x = x.replace(/^\s+|\s+$/g,"");
				  	if (x == c_name) {
			  			return unescape(y);
				    }
				}
			}
			
			return "";				
	  },
	  launchLfc: function (section, params,createCookie, refererSection) {
		  	console.log('helper.utils.launchLfc function called.');
		  	var cookieHaveLFC = helpers.utils.getCookie("haveLFC");
			if(!refererSection){
				refererSection = "Undefined";
			}	 
		    if (cookieHaveLFC != undefined && cookieHaveLFC == "yes") {
				// if create cookie is passed as true create the cookie before launching
				if (createCookie){
					helpers.utils.addCookie('haveLFC','yes',365);		
				}	
				if (createCookie){
					helpers.utils.gaTrackEvent('Launch LFC','Create cookie on launch',refererSection, 0, true);
				}else{
					helpers.utils.gaTrackEvent('Launch LFC','LFC cookie exists',refererSection, 0, true);		
				}
				var splitBy = (document.location.href.indexOf('#') != -1) ? '#' : '?';
				var urlHalves = String(document.location).split(splitBy);
				// launch lfc with prameters sent to the function + any parameters part of the url
				document.location = "lfconnect://?LFCSection=" + section + "&" + params + "&" + urlHalves[1] + "&referer=leapfrog.com" + "&refererSection=" + refererSection;
			}else{
				helpers.utils.gaTrackEvent('Launch LFC','No LFC cookie exists',refererSection, 0, true);
				document.location = "http://www.leapfrog.com/en/lfc/install_lf_connect.html";	
			}							
	  },
	  gaTrackEvent: function (arg0, arg1, arg2, arg3, arg4) {
		  console.log('helper.utils.gaTrackEvent function called.');
	  },
	  lfc : {
	      launchExternalLink : function (link) {
				link = escape(link); 
				link = "http://UPCApp/ServerEvent?event=LaunchExternalBrowser&redirectURL=" + link;
				document.location = link;
			},
		  launchInternalLink : function (url, width, height, resize, modal) {
				if(typeof url === "undefined" || url == '') {
					return;
				}
	
				var defaultResize = 1;
				var defaultModal = 1;
				var defaultWidth = 640;
				var defaultHeight = 480;
				
				if(typeof width == 'undefined' || width == -1) {
					width = defaultWidth;
				}
				
				if(typeof height == 'undefined' || height == -1) {
					height = defaultHeight;
				}
				
				if(typeof resize == 'undefined' || resize == -1) {
					resize = defaultResize;
				}
				
				if(typeof modal == 'undefined' || modal == -1) {
					modal = defaultModal;
				}

				document.location = 'http://UPCApp/BrowserWindow?resize='+resize+'&modal='+modal+'&width='+width+'&height='+height+'&url='+url;
			},

			fetchDeviceInventory : function (url) {
				if(typeof url == 'undefined' || url == "") {
					return;
				}
				
				console.log('Triggering device inventory - '+ url);
				document.location = url;
			},

			lfcFullScreenAppCenter : function (ignoreStarter, starterFlowParam){
				// go to new app center homepage and skip starter flow
				if (!ignoreStarter){
					ignoreStarter = 0;
				}else{
					ignoreStarter = 1;
				}
				
				if (!starterFlowParam){
					starterFlowParam = 0;
				}
				var currentUser = "";
				try {
					currentUser = LfSysEnv.currentUser()
				}
				catch(e){}
				
				var userParam = "";
				if (currentUser != ""){
					userParam = "%26ProfileIndex=" + currentUser;
				}
				
				var url = "http://UPCApp/ServerEvent?event=TabSwitch&device=App%20Center&tab=Landing" + "&addlParams=ignoreStarter%3D" + ignoreStarter + "%26starterFlow%3D" + starterFlowParam + userParam;
				console.log('Switching LFC to full screen: url = ' + url);
				document.location = url;
			}
	  }
  	}
  }

  return helpers;

});
